import { z } from 'zod';
import { settleAllowanceRequest } from './allowances.js';
export const ALLOWANCE_RESULT_BYTES = 65_536;
export const ALLOWANCE_EXECUTION_BODY_BYTES = 524_288;
const uuid = z.string().regex(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/);
const contextHash = z.string().regex(/^[0-9a-f]{64}$/);
export const beginAllowanceExecution = z.object({ reservationId: uuid, contextHash }).strict();
export const lookupAllowanceExecution = z.object({ requestKey: z.string().regex(/^[A-Za-z0-9_-]{1,128}$/), contextHash }).strict();
export const completeAllowanceExecution = settleAllowanceRequest.extend({
    contextHash,
    resultJson: z.string().refine(value => new TextEncoder().encode(value).byteLength <= ALLOWANCE_RESULT_BYTES)
        .refine(value => new TextDecoder().decode(new TextEncoder().encode(value)) === value)
        .refine(value => { try {
        JSON.parse(value);
        return true;
    }
    catch {
        return false;
    } }),
    // An engineering upper bound, not an approved customer retention policy.
    recoverySeconds: z.number().int().min(1).max(86_400),
}).strict();
export const beginAllowanceExecutionResponse = z.object({ status: z.enum(['started', 'pending', 'project_unavailable']) }).strict();
export const lookupAllowanceExecutionResponse = z.discriminatedUnion('status', [
    z.object({ status: z.literal('missing') }).strict(),
    z.object({ status: z.literal('pending') }).strict(),
    z.object({ status: z.literal('expired') }).strict(),
    z.object({ status: z.literal('project_unavailable') }).strict(),
    z.object({ status: z.literal('completed'), reservationId: uuid,
        resultJson: completeAllowanceExecution.shape.resultJson, actual: settleAllowanceRequest.shape.actual, overrun: z.boolean() }).strict(),
]);
export const completeAllowanceExecutionResponse = z.object({ status: z.enum(['completed', 'replay']), overrun: z.boolean() }).strict();
//# sourceMappingURL=allowance-executions.js.map